import { REGIONS } from 'state/intl/types';

import { getUSState } from './get-us-state';

const DELIVERY_FEE_DISCLOSURE_STATE_ABBREVIATIONS = new Set(['CA', 'OR', 'NV', 'AZ']);

type DeliveryFeeNoticeAddress = {
  state?: string;
  country?: string;
} | null | undefined;

const isCanadaDelivery = (
  deliveryAddress: DeliveryFeeNoticeAddress,
  region?: string
): boolean => {
  if (region === REGIONS.CA) {
    return true;
  }

  const country = deliveryAddress?.country?.trim().toUpperCase();
  return country === 'CA' || country === 'CANADA';
};

export const shouldShowDeliveryFeeNotice = ({
  deliveryAddress,
  region,
}: {
  deliveryAddress: DeliveryFeeNoticeAddress;
  region?: string;
}): boolean => {
  if (isCanadaDelivery(deliveryAddress, region)) {
    return true;
  }

  const state = deliveryAddress?.state?.trim();
  if (!state) {
    return false;
  }

  return DELIVERY_FEE_DISCLOSURE_STATE_ABBREVIATIONS.has(getUSState(state).toUpperCase());
};
